import { Link } from "react-router";
import { useAppContext } from "@/providers";
import { t } from "@/lib/i18n/messages";
import { Logo } from "@/components/layout/logo";

export function SiteFooter() {
  const { locale } = useAppContext();

  return (
    <footer className="bg-neutral-900 dark:bg-neutral-950 text-white py-12 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
        <Logo size="md" variant="light" />
        <nav className="flex flex-wrap justify-center gap-8 text-sm text-neutral-400">
          <Link className="hover:text-white transition-colors duration-base" to="#">
            {t(locale, "home")}
          </Link>
          <Link className="hover:text-white transition-colors duration-base" to="#">
            {t(locale, "about")}
          </Link>
          <Link className="hover:text-white transition-colors duration-base" to="/privacy-policy">
            {t(locale, "privacyPolicy")}
          </Link>
          <Link
            className="hover:text-white transition-colors duration-base"
            to="/terms-and-conditions"
          >
            {t(locale, "termsAndConditions")}
          </Link>
        </nav>
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-neutral-800 text-center text-xs text-neutral-500">
        Copyright NCircle &copy; 2026 All Rights Reserved
      </div>
    </footer>
  );
}
